import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

type Props = {
  hide: () => void;
  isShow: boolean;
  updateConfirmGlobalTarget: (data: null) => void;
  finish: () => void;
};

export const EditCompleteModal = ({
  hide,
  isShow,
  updateConfirmGlobalTarget,
  finish,
}: Props): React.ReactElement => {
  const end = (): void => {
    updateConfirmGlobalTarget(null);
    hide();
    finish();
  };
  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto">
        <div className="flex flex-col text-bluegray-700">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={end}
            />
          </div>
          <div className="font-bold text-bluegray-700 text-lg text-center">
            目標値とチャートが再作成されました
          </div>
          <div>
            <img
              src="/static/images/advisor/target-restart.svg"
              alt="再設定"
              className="mt-4 mx-auto"
              width="310"
              height="145"
            />
          </div>
          <div className="flex flex-row justify-center text-sm mt-4">
            目標値やチャートが再作成されました
            <br />
            新たな目標に向かって再出発しましょう
          </div>
          <button
            className="mt-8 p-2 text-gray-500 text-center text-sm"
            onClick={end}>
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
